import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, Transition as _Transition, withCtx as _withCtx, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1bf5bb26"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "w-full h-full" }
const _hoisted_2 = { class: "z-10 absolute h-screen w-screen overflow-auto" }

import { useConductorProvider } from "./utils/conductor";
import AnimatedBackground from "./components/organisms/AnimatedBackground.vue";
import DynamicTheme from "./components/atoms/DynamicTheme.vue";
import Page from "./utils/pages";
import { computed, watch, watchEffect } from "vue";
import { start as startTone } from "tone";
import { useI18n } from "vue-i18n";
import { RouterView, useRouter } from "vue-router";
import { useStore } from "vuex";
import { StoreData } from "./store";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { instruments, loop, active } = useConductorProvider();

const router = useRouter();
const currentPage = computed(() => router.currentRoute.value.name as Page);

async function startConductor() {
  await instruments.load();
  startTone();
  loop.start();
}

const { state } = useStore<StoreData>();

async function start(sound: boolean) {
  if (sound) {
    await startConductor();
  } else {
    instruments.setMute(true);
  }
  active.value = sound;
  router.push({ name: Page.Home });
}
watchEffect(() => {
  if (state.initMute !== null && currentPage.value === Page.Welcome) {
    start(state.initMute);
  } else if (state.initMute === null) {
    router.replace({ name: Page.Welcome });
  }
});

const transitionMode = computed(() =>
  [Page.Games, Page.Music, Page.Videos, Page.About].includes(currentPage.value)
    ? "in-out"
    : "default"
);

const { t, locale } = useI18n();
document.title = t("title");
watch([locale], () => {
  document.title = t("title");
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DynamicTheme, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(AnimatedBackground),
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_unref(RouterView), null, {
            default: _withCtx(({ Component }) => [
              _createVNode(_Transition, {
                name: _unref(state).initMute !== null && 'fade-page',
                mode: _unref(transitionMode)
              }, {
                default: _withCtx(() => [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
                ]),
                _: 2
              }, 1032, ["name", "mode"])
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _: 1
  }))
}
}

})